import { ArchiveX } from "lucide-react"

const EmptyData = ()=>{
  return (
    <div className="absolute w-full h-full inset-0 flex justify-center items-center flex-col gap-2 text-secondary">
        <ArchiveX size={140} strokeWidth={1.2} color="#ccc"/>
        <p className=" text-2xl font-bold">oops No Results found </p>
    </div>
  )
}
export default EmptyData